import { format, formatDistanceToNow } from "date-fns";
import { fr } from "date-fns/locale";

export function money(amount: number | string | null | undefined, currency: "EUR" | "USD" = "EUR"): string {
  if (amount === null || amount === undefined || amount === "") return "—";
  const n = typeof amount === "string" ? Number(amount) : amount;
  return new Intl.NumberFormat("fr-FR", { style: "currency", currency, minimumFractionDigits: 2 }).format(n);
}

export function dateShort(d: string | Date | null | undefined): string {
  if (!d) return "—";
  return format(new Date(d), "dd/MM/yyyy", { locale: fr });
}

export function dateTime(d: string | Date | null | undefined): string {
  if (!d) return "—";
  return format(new Date(d), "dd/MM/yyyy HH:mm", { locale: fr });
}

export function ago(d: string | Date | null | undefined): string {
  if (!d) return "jamais";
  return formatDistanceToNow(new Date(d), { locale: fr, addSuffix: true });
}
